import { LocalConfig } from "@/config";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import style from "./style.less";

const DownloadTip = (props) => {
  let history = useEnhancedHistory();
  const onCloseClick = () => {
    console.log("onDownloadClose");
    if (props && props.onClose && typeof props.onClose === "function") {
      props.onClose();
    }
  };
  return (
    <div class={style.outline}>
      <img
        class={style.close_btn}
        src={require("@/assets/images/download/close_btn.png").default}
        onClick={onCloseClick}
      />
      <div class={style.main_content} onClick={() => history.push(ChannelRemind("/downloadApp"))}>
        <img class={style.trophy} src={require("@/assets/images/download/trophy.png").default} />
        <img class={style.trophy2} src={LocalConfig.downloadTipTextImg} />
        <div style={{ flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
          <div class={style.download_box}>
            {/*<img class={style.android} src={require("@/assets/icons/android.svg").default} />*/}
            {/*<div class={style.download_btn_txt}>*/}
            {/*  <div>Free</div>*/}
            {/*  <div>Download</div>*/}
            {/*</div>*/}
            {/*<img class={style.download_icon} src={require("@/assets/icons/download.svg").default} />*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadTip;
